import React from "react";
import { Button } from "@ts-digital/vrc";
import { FormattedMessage, useIntl } from "react-intl";

const AskEditFooter = props => {
  const {
    bodyRequest,
    recipients,
    nextStep,
    prevStep,
    currentStep,
    onCancelClick,
    onSave,
    onSetError
  } = props;

  const genericCancel = useIntl().formatMessage({ id: "generic.cancel" });
  const genericBack = useIntl().formatMessage({ id: "generic.back" });
  const publishTemplate = useIntl().formatMessage({
    id: "ask.pages.edit.publishTemplate"
  });
  const genericSend = useIntl().formatMessage({ id: "generic.send" });
  const genericNext = useIntl().formatMessage({ id: "generic.next" });

  const emptyItems = () => {
    let empty = false;
    if (bodyRequest.items && bodyRequest.items.length > 0) {
      bodyRequest.items.map(item => {
        if (!item.label || (item.label && item.label.trim() === "")) {
          empty = true;
        }
        return null;
      });
    } else {
      empty = true;
    }
    return empty;
  };

  const setError = () => {
    let errorType = null;
    if (bodyRequest.items.length === 0) {
      errorType = "items";
    } else if (!bodyRequest.title || bodyRequest.title === "") {
      errorType = "title";
    } else if (!bodyRequest.category) {
      errorType = "category";
    } else if (emptyItems()) {
      errorType = "emptyItems";
    }
    if (onSetError) {
      if (errorType && errorType !== "none") {
        document.body.scrollTop = document.documentElement.scrollTop = 0;
      }
      onSetError(errorType);
    }
    return errorType;
  };

  return (
    <div className="askEdit-footer">
      <div className="askEdit-footer-preview">
        <Button
          kind="secondary"
          onClick={() => {
            currentStep === 2 ? onCancelClick() : prevStep();
          }}
        >
          {currentStep === 2
            ? genericCancel
            : genericBack}
        </Button>
      </div>
      <div className="askEdit-footer-actions">
        <Button
          onClick={() => {
            if (onSetError) {
              onSetError();
            }
            if (
              bodyRequest.items.length === 0 ||
              !bodyRequest.title ||
              bodyRequest.title === "" ||
              !bodyRequest.category ||
              emptyItems()
            ) {
              setError();
            } else {
              onSave(true);
            }
          }}
        >
          <FormattedMessage id="ask.saveDraft" />
        </Button>
        <Button
          onClick={() => {
            if (onSetError) {
              onSetError();
            }
            if (
              (currentStep === 2 &&
                (bodyRequest.items.length === 0 || !bodyRequest.title)) ||
              (currentStep === 3 &&
                recipients.length === 0 &&
                !bodyRequest.isShared && !bodyRequest.isForDots) ||
              !bodyRequest.category ||
              emptyItems()
            ) {
              setError();
            } else {
              nextStep();
            }
          }}
        >
          {currentStep === 3
            ? recipients.length === 0
              ? publishTemplate
              : genericSend
            : genericNext}
        </Button>
      </div>
    </div>
  );
};

export default AskEditFooter;
